import { FC, ReactNode } from 'react';
import { Button } from './styles';
import { TColorText } from 'shared/types';

interface ButtonTextProps {
	children: ReactNode;
	onClick?: () => void;
	isFullWidth?: boolean;
	color?: TColorText;
	padding?: string;
	disabled?: boolean;
}

export const ButtonText: FC<ButtonTextProps> = ({
	children,
	isFullWidth = false,
	color = 'default',
	onClick,
	padding,
	disabled = false,
}) => {
	return (
		<Button
			role="button-outlined"
			$isFullWidth={isFullWidth}
			$color={color}
			onClick={!window.matchMedia("(pointer: coarse)").matches ? onClick : undefined}
			onTouchStart={onClick}
			disabled={disabled}
			style={{ padding }}
		>
			{children}
		</Button>
	);
};
